import { render, staticRenderFns } from "./ImportReviewsAlert.vue?vue&type=template&id=d61d9cc6&scoped=true&"
import script from "./ImportReviewsAlert.vue?vue&type=script&lang=js&"
export * from "./ImportReviewsAlert.vue?vue&type=script&lang=js&"
import style0 from "./ImportReviewsAlert.vue?vue&type=style&index=0&id=d61d9cc6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d61d9cc6",
  null
  
)

export default component.exports